module.exports = __webpack_public_path__ + "img/selected6-min.71a58bb0.png";